import axios from "axios";
import { logout } from "src/redux/slices/auth";
import { deleteAllState } from "src/redux/slices/state";


const getStore = () => require("../redux/store").store;

const axiosInstance = axios.create({
  baseURL: "https://api.meuroom.com.br",
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const { accessToken } = getStore().getState().auth.auth;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
      const dispatch = getStore().dispatch;
      if(error?.response?.status === 403) {
        dispatch(logout({}))
        dispatch(deleteAllState())
      }
      return Promise.reject(error);
  }
);

export default axiosInstance;
